import React, { useEffect, useState } from 'react';

const Saving = () => {

    const [saving,setsaving] = useState([]);

    useEffect(()=>{
        fetch(`https://tracker-server-lake.vercel.app/transactions/Savings`)
        .then(res=>res.json())
        .then(d=> setsaving(d))
    },[])

  const getSaving =()=>{
    let val = saving.map(v=> parseInt(v.amount) )
    let sum = 0;
    for(let i = 0; i < val.length; i++){
        sum += val[i]
    }
    return sum
  }






    // const addSaving=(e)=>{

    // }
    return (
        <div>
            <h2 className='text-center py-6 text-2xl'>Total Saving  $<span className='text-green-500 font-medium'>{getSaving()}</span></h2>
           <div className="list">
            <form  className='form'>
                <input type="text" name='names' placeholder='Saving Description' />
                <input type="text" name='price' placeholder='Price' />
                <input type="date" name='date'  />
                <button className='btn btn-sm mt-2 rounded-none btn-warning'>Add</button>
            </form>
            <div className="overflow-x-auto mt-6">
      <table className="table w-full ">
       
         <tbody className=''>
            {
                saving.map(v=> <tr key={v._id}>
                    <td>{v.name}</td>
                    <td>{v.type}</td>
                    <td>{v.amount}</td>
                    <td>x</td>
                </tr>)
            }
         </tbody>
      </table>
    </div>
            </div>
        </div>
    );
};

export default Saving;